module.exports = __webpack_public_path__ + "static/media/grand1.afa12f1b.JPG";